import Vue from 'vue'

// Amplify settings
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
// import aws_exports from '@/aws-exports'

Amplify.Logger.LOG_LEVEL = process.env.NODE_ENV === 'development' ? 'DEBUG' : 'WARN'

// init amplify setting
Amplify.configure({
  // ...aws_exports,
  API: {
    endpoints: [
      {
        name: 'PVAPI',
        endpoint: process.env.VUE_APP_PVAPI
      },
      {
        name: "PERMISSIONS",
        endpoint: process.env.VUE_APP_permissions
      },
    ]
  },
  // PubSub: {
  //   clientId: 'webapp:' + new Date().getTime()
  // },
  Auth: {
    region: process.env.VUE_APP_region,
    userPoolId: process.env.VUE_APP_userPoolId,
    userPoolWebClientId: process.env.VUE_APP_userPoolWebClientId,
    identityPoolId: process.env.VUE_APP_identityPoolId,
    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
  }
})

Vue.use(AmplifyPlugin, AmplifyModules)

const sessionStorage = {
  install: (Vue) => {
    const config = {
      keyPrefix: 'PVCam',
      storage: window.sessionStorage
    }
    Vue.prototype.$session = AmplifyModules.Cache.createInstance(config)
  }
}

Vue.use(sessionStorage)
